export default {
  regionSelector: {
    chooseADisasterRegion: 'Wählen Sie hier eine Katastrophenregion aus',
    lastUpdate: 'Letztes Update'
  }
}
